<template>
	<div class="white-box">
		<div class="form-horizontal new-lg-form" @keyup.enter="validate()">
			<a href="javascript:void(0)" class="text-center db">
				<img :src="$env.ROOT + '/img/logo.png'">
			</a>
			<br/>
			<h3 class="box-title m-b-0">{{ $t("generals.reset_password") }}</h3>
			<template v-if="!hasPlatform">
				<div class="form-group">
					<div class="col-xs-12">
						<div :class="{ 'has-error' : errors.has('Cuenta') }">
							<label class="control-label">Nombre cuenta</label>
							<input
								v-model="data.platform"
								v-validate="'required|existsAccount'"
								class="form-control"
								type="text"
								name="Cuenta"
								placeholder="Cuenta"
								autofocus
								autocomplete="off">
							<small v-show="errors.has('Cuenta')" class="form-text text-danger">
								{{ errors.first('Cuenta') }}
							</small>
						</div>
					</div>
				</div>
			</template>
			<div class="form-group  m-t-20">
				<div class="col-xs-12">
					<div :class="{ 'has-error' : errors.has('Email Address') }">
						<label class="control-label">Email Address</label>
						<input
							v-model="data.email"
							v-validate="'required|email'"
							class="form-control"
							autofocus
							type="email"
							name="Email Address"
							autocomplete="off"
							placeholder="Email Address">
						<small v-show="errors.has('Email Address')" class="form-text text-danger">
							{{ errors.first('Email Address') }}
						</small>
					</div>
				</div>
			</div>
			<div class="form-group">
				<div class="col-md-12">
					<router-link :to="'/' + $i18n.locale + '/authentication/login'">
						{{ $t("generals.login") }}
					</router-link>
				</div>
			</div>
			<div class="form-group text-center m-t-20">
				<div class="col-xs-12">
					<button
						@click="validate"
						ref="btnReset"
						class="btn btn-primary btn-lg btn-block text-uppercase waves-effect waves-light"
						type="submit">
						{{ $t("generals.reset_password") }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Ladda from 'ladda'
	import swal from 'sweetalert2'

	export default {
		data () {
			return {
				data: {
					email: null,
					platform: this.getAccountCookie(),
				}
			}
		},
		created() {
			this.$validator.extend('existsAccount', {
				getMessage: field => 'La cuenta no esxiste.',
				validate: (value, [testProp]) => {
					if(value) {
						var data = {
							subdomain: value
						}
						return this.$http.post(this.$env.ROOT + '/api/gfactory/accounts/validation/exists', data)
						.then(response => {
							return {
								valid: response.body.valid
							}
						}).catch(function(response) {
							console.log(response)
						})
					} else {
						return false
					}
				}
			});

			if(this.$platform) {
				if(this.$platform.slug) {
					this.data.platform = this.$platform.slug
				}
			}
		},
		computed: {
			hasPlatform() {
				if(this.$platform) {
					return true
				} else {
					return false
				}
			}
		},
		methods: {
			getAccountCookie() {
				var account = null
				var re = new RegExp("account=([^;]+)")
				var value = re.exec(document.cookie)
				account =  (value != null) ? unescape(value[1]) : null;
				return account
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.reset()
					}
					return result
				})
			},
			reset () {
				var loading = Ladda.create(this.$refs.btnReset)
				loading.start()
				this.$http.post(this.$env.ROOT + '/api/' + this.$lang.getLang() + "/forgot/password", this.data)
				.then(response => {
					loading.stop()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					loading.stop()
					console.log(response)
					swal({
						title: response.statusText,
						text: response.body,
						type: "warning",
					})
				})
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/authentication/views/Forget.vue